import { render } from "./CarrinhoPagamentoView.vue?vue&type=template&id=65fdc148&scoped=true"
import script from "./CarrinhoPagamentoView.vue?vue&type=script&lang=js"
export * from "./CarrinhoPagamentoView.vue?vue&type=script&lang=js"

import "./CarrinhoPagamentoView.vue?vue&type=style&index=0&id=65fdc148&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fdc148"]])

export default __exports__